import React, { useContext, useEffect } from 'react';
import parse from 'html-react-parser';
import _ from 'lodash';
import classnames from 'classnames';

import Context from './Context';
import ProductDatatable from './ProductDatatable';
import ProductBadge from './ProductBadge';
// import badgeImg from '../../images/notified_body_no_1084.png';
import Icon from '../Icon';
import AddProductButton from '../AddProductButton';

import iconSofa from '../../images/skebi/icon-sofa.png';
import iconBed from '../../images/skebi/icon-bed.png';
import iconArmchair from '../../images/skebi/icon-armchair.png';
import iconSmallArmchair from '../../images/skebi/icon-small_armchair.png';

import futurizeImage from '../../images/futurize-logo.png';

const skebiIcons = {
  bed: iconBed,
  sofa: iconSofa,
  armchair: iconArmchair,
  small_armchair: iconSmallArmchair,
};

// const ProductCertifications = () => (
//   <>
//     <img
//       src={badgeImg}
//       alt="Notified body no. 1084"
//       title="Notified body no. 1084"
//       className="product-detail__img"
//     />
//
//     <hr />
//   </>
// );

// const skebiHostname = 'lab.skebi.net';
const skebiHostname = 'www.skebi.net';

const ProductDetail = () => {
  const {
    i18n,
    product,
    categories,
    product_badges,
    cartProductIds,
    toggleCartProductId,
  } = useContext(Context);

  const {
    id,
    name,
    description,
    attachment,
    has_custom_logo,
    custom_logo,
    custom_logo_external_url,
    skebi_renders,
    skebi_custom_product_renders,
    main_variant_id,
  } = product;

  const attachmentUrl = (attachment || {}).url;
  const parsedDescription = parse(description || '');
  const isStarred = _.includes(cartProductIds, id);

  const hasCustomLogoExternalUrl = custom_logo_external_url && custom_logo_external_url.toString().length > 0;
  const hasSkebiRenders = skebi_renders.length > 0 || skebi_custom_product_renders.length > 0;

  useEffect(() => {
    skebi_renders.forEach(({ render_model }) => {
      // https://lab.skebi.net/3d/skebi_futura_beta2/modal
      const src = `https://${skebiHostname}/3d/skebi_${render_model}/modal`;
      const script = document.createElement('script');

      script.src = src;
      script.type = "text/javascript";

      document.body.appendChild(script);
    });

    skebi_custom_product_renders.forEach(({ render_model }) => {
      const src = `https://${skebiHostname}/3d/skebi_${render_model}/modal`;
      const script = document.createElement('script');

      script.src = src;
      script.type = "text/javascript";

      document.body.appendChild(script);
    });
  }, []);

  return (
    <div className="product-detail">
      <ProductDatatable />

      <div className="product-detail__paragraph">
        {parsedDescription}
      </div>

      <div className="product-detail__icons">
        <hr />

        {
          hasSkebiRenders && (
            <>
              <div className="row">
                <div className="col-sm-7">
                  <p>
                    <strong className="text-dark">{i18n.skebi_title}</strong>
                    <br />
                    {i18n.skebi_subtitle.replace('%NAME%', name)}
                  </p>
                </div>

                <div className="col-sm-5">
                  <a href={`/${gon.locale}/configurator`} title="Futurize">
                    <img src={futurizeImage} alt="Futurize" className="w-100" />
                  </a>
                </div>
              </div>
              <div className="product-detail__skebi-icons d-flex flex-wrap">
                {
                  skebi_renders.map(({ icon, render_model, render_key, id }) => (
                    <div
                      key={id}
                      id={`skebi_${render_model}`}
                      data-model={render_model}
                      data-key={render_key}
                      data-force={main_variant_id}
                      data-lang={gon.locale}
                      data-cliente="futura"
                      data-ver=""
                      data-closepopup={i18n.skebi_close_popup}
                      data-closeconfirm={i18n.skebi_close_confirm}
                    >
                      <img
                        src={skebiIcons[icon]}
                        alt={icon}
                        className="product-detail__skebi-icon"
                      />
                    </div>
                  ))
                }
                {
                  skebi_custom_product_renders.map(({ icon, render_model, render_shareid, id }) => (
                    <div
                      key={id}
                      id={`skebi_${render_model}`}
                      data-model={render_model}
                      data-shareid={render_shareid}
                      data-lang={gon.locale}
                      data-cliente="futura"
                      data-ver=""
                      data-closepopup={i18n.skebi_close_popup}
                      data-closeconfirm={i18n.skebi_close_confirm}
                    >
                      <img
                        src={skebiIcons[icon]}
                        alt={icon}
                        className="product-detail__skebi-icon"
                      />
                    </div>
                  ))
                }
              </div>

              <hr />
            </>
          )
        }

        {
          categories.map(({ icon, name, ...props }) => (
            <img
              key={props.id}
              src={(icon || { url: null }).thumb.url}
              alt={name}
              title={name}
              className="product-detail__img"
            />
          ))
        }

        { categories.length > 0 && (<hr />) }

        {
          attachmentUrl && (
            <a
              href={attachmentUrl}
              className="product-detail__cta"
              target="_blank"
              title="Download PDF"
              rel="noreferrer"
            >
              <Icon name="file-pdf" family="far" size="2x" fw />
            </a>
          )
        }

        <AddProductButton
          className={classnames('product-detail__cta', { 'product-detail__cta--starred': isStarred })}
          isStarred={isStarred}
          onClick={toggleCartProductId}
          productId={id}
          i18n={i18n}
          iconProps={{ size: '2x' }}
        />

        {
          has_custom_logo && hasCustomLogoExternalUrl && (
            <a href={custom_logo_external_url} target="_blank" className="product-detail__custom-logo">
              <img
                src={custom_logo.small.url}
                className="product-detail__custom-logo-img"
              />
            </a>
          )
        }

        {
          has_custom_logo && !hasCustomLogoExternalUrl && (
            <span className="product-detail__custom-logo">
              <img
                src={custom_logo.small.url}
                className="product-detail__custom-logo-img"
              />
            </span>
          )
        }

        {
          product_badges.map((badge) => (
            <ProductBadge key={badge.id} {...badge} />
          ))
        }
      </div>
    </div>
  );
};

export default ProductDetail;
